import { isEmpty } from 'lodash'
import moment from 'moment'

export const momentDateByLanguage = (date, language, format) => {
  const momentDate = moment.utc(date).locale(language).format(format)

  if (language === 'TH') {
    return `วัน${momentDate}`
  }

  return momentDate
}

export const prepareMeetingInfo = (booking, language) => {
  if (isEmpty(booking)) return

  let startTime = booking.startDatetime.split('T')
  startTime = startTime[1].split(':')
  startTime = startTime[0] + '.' + startTime[1]

  let endTime = booking.endDatetime.split('T')
  endTime = endTime[1].split(':')
  endTime = endTime[0] + '.' + endTime[1]

  let start = startTime
  let end = endTime

  return {
    bookingId: booking.bookingId,
    projectName: booking.projectName,
    roomId: booking.roomId,
    spaceType: booking.spaceType,
    date: booking.startDatetime,
    location: booking.roomName,
    startTime: start,
    duration: `${start} - ${end}`,
    status: booking.status,
    description: booking.description || '-',
    owner: booking.owner,
    guests: booking.guest,
    pinCode: booking.pincode,
    meetingLink: booking.meetingLink,
    meetingLinkType: booking.meetingLinkType,
    websiteUrl: booking.websiteUrl,
    controlRoomManualUrl: booking.controlRoomManualUrl,
    isEditable: booking.isEditable
  }
}

export const prepareRawBookingDetail = (bookingData) => {
  return {
    force: false,
    buildingId: bookingData.buildingId,
    companyId: bookingData.companyId,
    description: bookingData.description,
    endDatetime: bookingData.endDatetime,
    startDatetime: bookingData.startDatetime,
    floorId: bookingData.floorId,
    guest: bookingData.guest,
    isPrivate: bookingData.isPrivate,
    meetingLink: bookingData.meetingLink,
    notificationTime: bookingData.notificationTime,
    owner: bookingData.owner,
    projectName: bookingData.projectName,
    recurrence: bookingData.recurrence,
    roomId: bookingData.roomId,
    isEditable: bookingData.isEditable
  }
}

export const categorizeOrders = (orders) => {
  const categorizedOrders = {}

  orders.forEach((order) => {
    if (order.items[0].type in categorizedOrders) {
      const previousOrders = categorizedOrders[order.items[0].type]
      categorizedOrders[order.items[0].type] = [...previousOrders, order]
    } else {
      categorizedOrders[order.items[0].type] = [order]
    }
  })
  
  return categorizedOrders
}
